import { SB } from '@play-co/replicant';
import { getLocaleConfig } from 'src/replicant/creatives/text';
import {
  createFlexMessageTemplate,
  createFlexContainer,
  createOpenGameAction,
} from './utils';

/**
 * Assets for message
 */
export const miniappCreativeAssets: Record<string, string> = {
  'miniapp/welcome/en': 'private/chatbot/miniapp/welcome_en.png',
  'miniapp/welcome/ja': 'private/chatbot/miniapp/welcome_ja.png',
};

/**
 * Create MiniApp welcome message, see:
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const miniappWelcome = createFlexMessageTemplate(
  SB.object({
    locale: SB.tuple(['en', 'ja'] as const),
  }),
  (data, payload, api) => {
    const altText = getLocaleConfig(data.locale).resurrect.playNow.text;
    const background = api.getAssetPath(`miniapp/welcome/${data.locale}`);

    const template = createFlexContainer(altText, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(altText, payload),
      body: {
        type: 'box',
        layout: 'vertical',
        paddingAll: '0px',
        contents: [
          {
            type: 'image',
            url: background,
            size: 'full',
            aspectMode: 'cover',
            aspectRatio: '1.3:1',
            gravity: 'center',
          },
        ],
      },
    });

    return template;
  },
);
